/**
 * Do not edit directly, this file was auto-generated.
 */

export const kdsColorMagenta50 = "#fff5ff";
export const kdsColorMagenta100 = "#ffecfe";
export const kdsColorMagenta200 = "#ffc5fb";
export const kdsColorMagenta300 = "#ff9af8";
export const kdsColorMagenta400 = "#ff64f4";
export const kdsColorMagenta500 = "#ff37f0";
export const kdsColorMagenta600 = "#d91dcb";
export const kdsColorMagenta700 = "#cf07be";
export const kdsColorMagenta800 = "#a6069a";
export const kdsColorMagenta900 = "#790070";
export const kdsColorMagenta950 = "#5d0055";
export const kdsColorPurple50 = "#f5f3ff";
export const kdsColorPurple100 = "#ede9fe";
export const kdsColorPurple200 = "#ddd6fe";
export const kdsColorPurple300 = "#c4b5fd";
export const kdsColorPurple400 = "#a78bfa";
export const kdsColorPurple500 = "#8b5cf6";
export const kdsColorPurple600 = "#7c3aed";
export const kdsColorPurple700 = "#6d28d9";
export const kdsColorPurple800 = "#5b21b6";
export const kdsColorPurple900 = "#4c1d95";
export const kdsColorPurple950 = "#2e1065";
export const kdsColorBlue50 = "#eff6ff";
export const kdsColorBlue100 = "#dbeafe";
export const kdsColorBlue200 = "#bfdbfe";
export const kdsColorBlue300 = "#93c5fd";
export const kdsColorBlue400 = "#60a5fa";
export const kdsColorBlue500 = "#3b82f6";
export const kdsColorBlue600 = "#3a65dc";
export const kdsColorBlue700 = "#003ad6";
export const kdsColorBlue800 = "#0031ba";
export const kdsColorBlue900 = "#00257d";
export const kdsColorBlue950 = "#001858";
export const kdsColorLightblue50 = "#e6f7ff";
export const kdsColorLightblue100 = "#d8f3fe";
export const kdsColorLightblue200 = "#9de1ff";
export const kdsColorLightblue300 = "#6ad2ff";
export const kdsColorLightblue400 = "#2dc0ff";
export const kdsColorLightblue500 = "#00adf8";
export const kdsColorLightblue600 = "#029adc";
export const kdsColorLightblue700 = "#036fa1";
export const kdsColorLightblue800 = "#075e85";
export const kdsColorLightblue900 = "#0c4e6e";
export const kdsColorLightblue950 = "#083249";
export const kdsColorTeal50 = "#f0fdfa";
export const kdsColorTeal100 = "#ccfbf1";
export const kdsColorTeal200 = "#99f6e4";
export const kdsColorTeal300 = "#5eead4";
export const kdsColorTeal400 = "#2dd4bf";
export const kdsColorTeal500 = "#14b8a6";
export const kdsColorTeal600 = "#0d9488";
export const kdsColorTeal700 = "#0f766e";
export const kdsColorTeal800 = "#115e59";
export const kdsColorTeal900 = "#134e4a";
export const kdsColorTeal950 = "#042f2e";
export const kdsColorCyan50 = "#ecfeff";
export const kdsColorCyan100 = "#cffafe";
export const kdsColorCyan200 = "#a5f3fc";
export const kdsColorCyan300 = "#67e8f9";
export const kdsColorCyan400 = "#22d3ee";
export const kdsColorCyan500 = "#06b6d4";
export const kdsColorCyan600 = "#0891b2";
export const kdsColorCyan700 = "#0e7490";
export const kdsColorCyan800 = "#155e75";
export const kdsColorCyan900 = "#164e63";
export const kdsColorCyan950 = "#083344";
export const kdsColorGreen50 = "#f0fdf4";
export const kdsColorGreen100 = "#dcfce7";
export const kdsColorGreen200 = "#bbf7d0";
export const kdsColorGreen300 = "#86efac";
export const kdsColorGreen400 = "#4ade80";
export const kdsColorGreen500 = "#22c55e";
export const kdsColorGreen600 = "#16a34a";
export const kdsColorGreen700 = "#15803d";
export const kdsColorGreen800 = "#166534";
export const kdsColorGreen900 = "#14532d";
export const kdsColorGreen950 = "#052e16";
export const kdsColorLime50 = "#f7fee7";
export const kdsColorLime100 = "#ecfccb";
export const kdsColorLime200 = "#d9f99d";
export const kdsColorLime300 = "#bef264";
export const kdsColorLime400 = "#a3e635";
export const kdsColorLime500 = "#84cc16";
export const kdsColorLime600 = "#65a30d";
export const kdsColorLime700 = "#4d7c0f";
export const kdsColorLime800 = "#3f6212";
export const kdsColorLime900 = "#365314";
export const kdsColorLime950 = "#1a2e05";
export const kdsColorYellow50 = "#fefce8";
export const kdsColorYellow100 = "#fef9c3";
export const kdsColorYellow200 = "#fef08a";
export const kdsColorYellow300 = "#fde047";
export const kdsColorYellow400 = "#facc15";
export const kdsColorYellow500 = "#eab308";
export const kdsColorYellow600 = "#ca8a04";
export const kdsColorYellow700 = "#a16207";
export const kdsColorYellow800 = "#854d0e";
export const kdsColorYellow900 = "#713f12";
export const kdsColorYellow950 = "#422006";
export const kdsColorOrange50 = "#fff7ed";
export const kdsColorOrange100 = "#ffedd5";
export const kdsColorOrange200 = "#fed7aa";
export const kdsColorOrange300 = "#fdba74";
export const kdsColorOrange400 = "#fb923c";
export const kdsColorOrange500 = "#f97316";
export const kdsColorOrange600 = "#ea580c";
export const kdsColorOrange700 = "#c2410c";
export const kdsColorOrange800 = "#9a3412";
export const kdsColorOrange900 = "#7c2d12";
export const kdsColorOrange950 = "#431407";
export const kdsColorRed50 = "#fef2f2";
export const kdsColorRed100 = "#fee2e2";
export const kdsColorRed200 = "#fecaca";
export const kdsColorRed300 = "#fca5a5";
export const kdsColorRed400 = "#f87171";
export const kdsColorRed500 = "#ef4444";
export const kdsColorRed600 = "#dc2626";
export const kdsColorRed700 = "#b91c1c";
export const kdsColorRed800 = "#991b1b";
export const kdsColorRed900 = "#7f1d1d";
export const kdsColorRed950 = "#450a0a";
export const kdsColorGray50 = "#faf9f8";
export const kdsColorGray100 = "#f4f4f2";
export const kdsColorGray200 = "#ecece6";
export const kdsColorGray300 = "#dbd5d0";
export const kdsColorGray400 = "#a69a91";
export const kdsColorGray500 = "#7c7168";
export const kdsColorGray600 = "#6c6057";
export const kdsColorGray700 = "#50463f";
export const kdsColorGray800 = "#403730";
export const kdsColorGray900 = "#322a24";
export const kdsColorGray950 = "#1a1712";
export const kdsColorWhite = "#ffffff";
export const kdsColorBlack = "#000000";
export const kdsColorTransparent = "transparent";
export const kdsColorPrimary50 = "#eff6ff";
export const kdsColorPrimary100 = "#dbeafe";
export const kdsColorPrimary200 = "#bfdbfe";
export const kdsColorPrimary300 = "#93c5fd";
export const kdsColorPrimary400 = "#60a5fa";
export const kdsColorPrimary500 = "#3b82f6";
export const kdsColorPrimary600 = "#3a65dc";
export const kdsColorPrimary700 = "#003ad6";
export const kdsColorPrimary800 = "#0031ba";
export const kdsColorPrimary900 = "#00257d";
export const kdsColorPrimary950 = "#001858";
export const kdsColorSecondary50 = "#fff5ff";
export const kdsColorSecondary100 = "#ffecfe";
export const kdsColorSecondary200 = "#ffc5fb";
export const kdsColorSecondary300 = "#ff9af8";
export const kdsColorSecondary400 = "#ff64f4";
export const kdsColorSecondary500 = "#ff37f0";
export const kdsColorSecondary600 = "#d91dcb";
export const kdsColorSecondary700 = "#cf07be";
export const kdsColorSecondary800 = "#a6069a";
export const kdsColorSecondary900 = "#790070";
export const kdsColorSecondary950 = "#5d0055";
export const kdsColorInfo50 = "#e6f7ff";
export const kdsColorInfo100 = "#d8f3fe";
export const kdsColorInfo200 = "#9de1ff";
export const kdsColorInfo300 = "#6ad2ff";
export const kdsColorInfo400 = "#2dc0ff";
export const kdsColorInfo500 = "#00adf8";
export const kdsColorInfo600 = "#029adc";
export const kdsColorInfo700 = "#036fa1";
export const kdsColorInfo800 = "#075e85";
export const kdsColorInfo900 = "#0c4e6e";
export const kdsColorInfo950 = "#083249";
export const kdsColorSuccess50 = "#f0fdf4";
export const kdsColorSuccess100 = "#dcfce7";
export const kdsColorSuccess200 = "#bbf7d0";
export const kdsColorSuccess300 = "#86efac";
export const kdsColorSuccess400 = "#4ade80";
export const kdsColorSuccess500 = "#22c55e";
export const kdsColorSuccess600 = "#16a34a";
export const kdsColorSuccess700 = "#15803d";
export const kdsColorSuccess800 = "#166534";
export const kdsColorSuccess900 = "#14532d";
export const kdsColorSuccess950 = "#052e16";
export const kdsColorWarning50 = "#fff7ed";
export const kdsColorWarning100 = "#ffedd5";
export const kdsColorWarning200 = "#fed7aa";
export const kdsColorWarning300 = "#fdba74";
export const kdsColorWarning400 = "#fb923c";
export const kdsColorWarning500 = "#f97316";
export const kdsColorWarning600 = "#ea580c";
export const kdsColorWarning700 = "#c2410c";
export const kdsColorWarning800 = "#9a3412";
export const kdsColorWarning900 = "#7c2d12";
export const kdsColorWarning950 = "#431407";
export const kdsColorDanger50 = "#fef2f2";
export const kdsColorDanger100 = "#fee2e2";
export const kdsColorDanger200 = "#fecaca";
export const kdsColorDanger300 = "#fca5a5";
export const kdsColorDanger400 = "#f87171";
export const kdsColorDanger500 = "#ef4444";
export const kdsColorDanger600 = "#dc2626";
export const kdsColorDanger700 = "#b91c1c";
export const kdsColorDanger800 = "#991b1b";
export const kdsColorDanger900 = "#7f1d1d";
export const kdsColorDanger950 = "#450a0a";
export const kdsColorNeutral0 = "#ffffff";
export const kdsColorNeutral50 = "#faf9f8";
export const kdsColorNeutral100 = "#f4f4f2";
export const kdsColorNeutral200 = "#ecece6";
export const kdsColorNeutral300 = "#dbd5d0";
export const kdsColorNeutral400 = "#a69a91";
export const kdsColorNeutral500 = "#7c7168";
export const kdsColorNeutral600 = "#6c6057";
export const kdsColorNeutral700 = "#50463f";
export const kdsColorNeutral800 = "#403730";
export const kdsColorNeutral900 = "#322a24";
export const kdsColorNeutral950 = "#1a1712";
export const kdsColorNeutral1000 = "#000000";
export const kdsColorForegroundDefault = "#322a24";
export const kdsColorForegroundSubtle = "#50463f";
export const kdsColorForegroundMinimal = "#7c7168";
export const kdsColorForegroundInverse = "#ffffff";
export const kdsColorForegroundSelected = "#003ad6";
export const kdsColorForegroundOnSelected = "#ffffff";
export const kdsColorForegroundDisabled = "#a69a91";
export const kdsColorForegroundPrimary = "#003ad6";
export const kdsColorForegroundOnPrimary = "#ffffff";
export const kdsColorForegroundSecondary = "#cf07be";
export const kdsColorForegroundOnSecondary = "#ffffff";
export const kdsColorForegroundInfo = "#036fa1";
export const kdsColorForegroundOnInfo = "#ffffff";
export const kdsColorForegroundSuccess = "#15803d";
export const kdsColorForegroundOnSuccess = "#ffffff";
export const kdsColorForegroundWarning = "#c2410c";
export const kdsColorForegroundOnWarning = "#ffffff";
export const kdsColorForegroundDanger = "#b91c1c";
export const kdsColorForegroundOnDanger = "#ffffff";
export const kdsColorForegroundNeutral = "#50463f";
export const kdsColorForegroundOnNeutral = "#ffffff";
export const kdsColorBackgroundDefault = "#ffffff";
export const kdsColorBackgroundMinimal = "#faf9f8";
export const kdsColorBackgroundSubtle = "#f4f4f2";
export const kdsColorBackgroundSelected = "#003ad6";
export const kdsColorBackgroundDisabled = "#f4f4f2";
export const kdsColorBackgroundPrimary = "#003ad6";
export const kdsColorBackgroundSecondary = "#cf07be";
export const kdsColorBackgroundInfo = "#036fa1";
export const kdsColorBackgroundSuccess = "#15803d";
export const kdsColorBackgroundWarning = "#c2410c";
export const kdsColorBackgroundDanger = "#b91c1c";
export const kdsColorBackgroundNeutral = "#50463f";
export const kdsColorBorderStrong = "#50463f";
export const kdsColorBorderMedium = "#7c7168";
export const kdsColorBorderSubtle = "#dbd5d0";
export const kdsColorBorderMinimal = "#ecece6";
export const kdsColorBorderFocused = "#3b82f6";
export const kdsColorBorderSelected = "#003ad6";
export const kdsColorBorderDisabled = "#a69a91";
export const kdsColorBorderPrimary = "#003ad6";
export const kdsColorBorderSecondary = "#cf07be";
export const kdsColorBorderInfo = "#036fa1";
export const kdsColorBorderSuccess = "#15803d";
export const kdsColorBorderWarning = "#c2410c";
export const kdsColorBorderDanger = "#b91c1c";
export const kdsColorBorderNeutral = "#50463f";
export const kdsColorShadowMinimal = "#faf9f8";
export const kdsColorShadowSubtle = "#f4f4f2";
export const kdsColorShadowFocused = "#eff6ff";
export const kdsColorShadowWarning = "#fff7ed";
export const kdsFontFamilyBase = "'Atlas Grotesk', Arial, sans-serif";
export const kdsFontWeightNormal = 400;
export const kdsFontWeightMedium = 500;
export const kdsFontWeightBold = 700;
export const kdsFontWeightInput = 400;
export const kdsFontWeightPlaceholder = 400;
export const kdsFontStyleNormal = "normal";
export const kdsFontStyleItalic = "italic";
export const kdsFontSizeXs = "12px";
export const kdsFontSizeSm = "14px";
export const kdsFontSizeMd = "16px";
export const kdsFontSizeLg = "18px";
export const kdsFontSizeXl = "20px";
export const kdsFontSize2xl = "24px";
export const kdsFontSize3xl = "32px";
export const kdsFontSize4xl = "40px";
export const kdsFontSize5xl = "48px";
export const kdsFontSize6xl = "60px";
export const kdsFontSize7xl = "72px";
export const kdsFontSize8xl = "96px";
export const kdsFontSize9xl = "128px";
export const kdsFontSizeInputMedium = "14px";
export const kdsFontSizeInputLarge = "16px";
export const kdsLineHeight3 = "12px";
export const kdsLineHeight4 = "16px";
export const kdsLineHeight5 = "20px";
export const kdsLineHeight6 = "24px";
export const kdsLineHeight7 = "28px";
export const kdsLineHeight8 = "32px";
export const kdsLineHeight9 = "36px";
export const kdsLineHeight10 = "40px";
export const kdsLineHeightNone = "1";
export const kdsLineHeightTight = "1.2";
export const kdsLineHeightSnug = "1.375";
export const kdsLineHeightNormal = "1.5";
export const kdsLineHeightRelaxed = "1.625";
export const kdsLineHeightLoose = "2";
export const kdsLineHeightInputMedium = "20px";
export const kdsLineHeightInputLarge = "24px";
export const kdsLetterSpacingTighter = "-0.05em";
export const kdsLetterSpacingTight = "-0.025em";
export const kdsLetterSpacingNormal = "0";
export const kdsLetterSpacingWide = "0.025em";
export const kdsLetterSpacingWider = "0.05em";
export const kdsLetterSpacingWidest = "0.1em";
export const kdsBreakpointSmall = "576px";
export const kdsBreakpointMedium = "768px";
export const kdsBreakpointLarge = "1024px";
export const kdsBreakpointXlarge = "1440px";
export const kdsSpacing0 = "0";
export const kdsSpacing1 = "4px";
export const kdsSpacing2 = "8px";
export const kdsSpacing3 = "12px";
export const kdsSpacing4 = "16px";
export const kdsSpacing5 = "20px";
export const kdsSpacing6 = "24px";
export const kdsSpacing7 = "28px";
export const kdsSpacing8 = "32px";
export const kdsSpacing9 = "36px";
export const kdsSpacing10 = "40px";
export const kdsSpacing12 = "48px";
export const kdsSpacing14 = "56px";
export const kdsSpacing16 = "64px";
export const kdsSpacing20 = "80px";
export const kdsSpacing24 = "96px";
export const kdsSpacing28 = "112px";
export const kdsSpacing32 = "128px";
export const kdsSpacing36 = "144px";
export const kdsSpacing40 = "160px";
export const kdsSpacing44 = "176px";
export const kdsSpacing48 = "192px";
export const kdsSpacing56 = "224px";
export const kdsSpacing60 = "240px";
export const kdsSpacing64 = "256px";
export const kdsSpacing72 = "288px";
export const kdsSpacing80 = "320px";
export const kdsSpacing96 = "384px";
export const kdsSpacingPx = "1px";
export const kdsSpacing05 = "2px";
export const kdsSpacing15 = "6px";
export const kdsSpacing25 = "10px";
export const kdsSpacing35 = "14px";
export const kdsSpacing45 = "18px";
export const kdsBorderRadiusNone = "0";
export const kdsBorderRadiusSmall = "2px";
export const kdsBorderRadiusBase = "4px";
export const kdsBorderRadiusMedium = "6px";
export const kdsBorderRadiusLarge = "8px";
export const kdsBorderRadiusXlarge = "12px";
export const kdsBorderRadius2xlarge = "16px";
export const kdsBorderRadius3xlarge = "24px";
export const kdsBorderRadiusFull = "9999px";
export const kdsEaseIn = "0.42, 0, 1, 1";
export const kdsEaseOut = "0.29, 0, 0.83, 0.67";
export const kdsEaseInOut = "0.42, 0, 0.58, 1";
export const kdsBoxShadowNone = "none";
export const kdsBoxShadowSmall = "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px";
export const kdsBoxShadowBase = "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px";
export const kdsBoxShadowMedium = "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px";
export const kdsBoxShadowLarge = "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px";
export const kdsBoxShadowXlarge = "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px";
export const kdsBoxShadow2xlarge = "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.25) 0px 25px 50px -12px";
export const kdsButtonColorBackgroundSolidPrimary = "#003ad6";
export const kdsButtonColorBackgroundSolidPrimaryHovered = "#0031ba";
export const kdsButtonColorBackgroundSolidPrimaryPressed = "#00257d";
export const kdsButtonColorBackgroundSolidSecondary = "#cf07be";
export const kdsButtonColorBackgroundSolidSecondaryHovered = "#a6069a";
export const kdsButtonColorBackgroundSolidSecondaryPressed = "#790070";
export const kdsButtonColorBackgroundSolidSuccess = "#15803d";
export const kdsButtonColorBackgroundSolidSuccessHovered = "#166534";
export const kdsButtonColorBackgroundSolidSuccessPressed = "#14532d";
export const kdsButtonColorBackgroundSolidWarning = "#c2410c";
export const kdsButtonColorBackgroundSolidWarningHovered = "#9a3412";
export const kdsButtonColorBackgroundSolidWarningPressed = "#7c2d12";
export const kdsButtonColorBackgroundSolidDanger = "#b91c1c";
export const kdsButtonColorBackgroundSolidDangerHovered = "#991b1b";
export const kdsButtonColorBackgroundSolidDangerPressed = "#7f1d1d";
export const kdsButtonColorBackgroundSolidNeutral = "#50463f";
export const kdsButtonColorBackgroundSolidNeutralHovered = "#403730";
export const kdsButtonColorBackgroundSolidNeutralPressed = "#322a24";
export const kdsButtonColorBackgroundSolidDisabled = "#a69a91";
export const kdsButtonColorBackgroundOutlinePrimary = "transparent";
export const kdsButtonColorBackgroundOutlinePrimaryHovered = "#eff6ff";
export const kdsButtonColorBackgroundOutlinePrimaryPressed = "#dbeafe";
export const kdsButtonColorBackgroundOutlineSecondary = "transparent";
export const kdsButtonColorBackgroundOutlineSecondaryHovered = "#fff5ff";
export const kdsButtonColorBackgroundOutlineSecondaryPressed = "#ffecfe";
export const kdsButtonColorBackgroundOutlineSuccess = "transparent";
export const kdsButtonColorBackgroundOutlineSuccessHovered = "#f0fdf4";
export const kdsButtonColorBackgroundOutlineSuccessPressed = "#dcfce7";
export const kdsButtonColorBackgroundOutlineWarning = "transparent";
export const kdsButtonColorBackgroundOutlineWarningHovered = "#fff7ed";
export const kdsButtonColorBackgroundOutlineWarningPressed = "#ffedd5";
export const kdsButtonColorBackgroundOutlineDanger = "transparent";
export const kdsButtonColorBackgroundOutlineDangerHovered = "#fef2f2";
export const kdsButtonColorBackgroundOutlineDangerPressed = "#fee2e2";
export const kdsButtonColorBackgroundOutlineNeutral = "transparent";
export const kdsButtonColorBackgroundOutlineNeutralHovered = "#faf9f8";
export const kdsButtonColorBackgroundOutlineNeutralPressed = "#f4f4f2";
export const kdsButtonColorBackgroundOutlineDisabled = "transparent";
export const kdsButtonColorBackgroundLinkPrimary = "transparent";
export const kdsButtonColorBackgroundLinkPrimaryHovered = "transparent";
export const kdsButtonColorBackgroundLinkPrimaryPressed = "transparent";
export const kdsButtonColorBackgroundLinkSecondary = "transparent";
export const kdsButtonColorBackgroundLinkSecondaryHovered = "transparent";
export const kdsButtonColorBackgroundLinkSecondaryPressed = "transparent";
export const kdsButtonColorBackgroundLinkSuccess = "transparent";
export const kdsButtonColorBackgroundLinkSuccessHovered = "transparent";
export const kdsButtonColorBackgroundLinkSuccessPressed = "transparent";
export const kdsButtonColorBackgroundLinkWarning = "transparent";
export const kdsButtonColorBackgroundLinkWarningHovered = "transparent";
export const kdsButtonColorBackgroundLinkWarningPressed = "transparent";
export const kdsButtonColorBackgroundLinkDanger = "transparent";
export const kdsButtonColorBackgroundLinkDangerHovered = "transparent";
export const kdsButtonColorBackgroundLinkDangerPressed = "transparent";
export const kdsButtonColorBackgroundLinkNeutral = "transparent";
export const kdsButtonColorBackgroundLinkNeutralHovered = "transparent";
export const kdsButtonColorBackgroundLinkNeutralPressed = "transparent";
export const kdsButtonColorBackgroundLinkDisabled = "transparent";
export const kdsButtonColorForegroundSolidPrimary = "#ffffff";
export const kdsButtonColorForegroundSolidPrimaryHovered = "#ffffff";
export const kdsButtonColorForegroundSolidPrimaryPressed = "#ffffff";
export const kdsButtonColorForegroundSolidSecondary = "#ffffff";
export const kdsButtonColorForegroundSolidSecondaryHovered = "#ffffff";
export const kdsButtonColorForegroundSolidSecondaryPressed = "#ffffff";
export const kdsButtonColorForegroundSolidSuccess = "#ffffff";
export const kdsButtonColorForegroundSolidSuccessHovered = "#ffffff";
export const kdsButtonColorForegroundSolidSuccessPressed = "#ffffff";
export const kdsButtonColorForegroundSolidWarning = "#ffffff";
export const kdsButtonColorForegroundSolidWarningHovered = "#ffffff";
export const kdsButtonColorForegroundSolidWarningPressed = "#ffffff";
export const kdsButtonColorForegroundSolidDanger = "#ffffff";
export const kdsButtonColorForegroundSolidDangerHovered = "#ffffff";
export const kdsButtonColorForegroundSolidDangerPressed = "#ffffff";
export const kdsButtonColorForegroundSolidNeutral = "#ffffff";
export const kdsButtonColorForegroundSolidNeutralHovered = "#ffffff";
export const kdsButtonColorForegroundSolidNeutralPressed = "#ffffff";
export const kdsButtonColorForegroundSolidDisabled = "#ffffff";
export const kdsButtonColorForegroundOutlinePrimary = "#003ad6";
export const kdsButtonColorForegroundOutlinePrimaryHovered = "#0031ba";
export const kdsButtonColorForegroundOutlinePrimaryPressed = "#00257d";
export const kdsButtonColorForegroundOutlineSecondary = "#cf07be";
export const kdsButtonColorForegroundOutlineSecondaryHovered = "#a6069a";
export const kdsButtonColorForegroundOutlineSecondaryPressed = "#790070";
export const kdsButtonColorForegroundOutlineNeutral = "#50463f";
export const kdsButtonColorForegroundOutlineSuccess = "#15803d";
export const kdsButtonColorForegroundOutlineSuccessHovered = "#166534";
export const kdsButtonColorForegroundOutlineSuccessPressed = "#14532d";
export const kdsButtonColorForegroundOutlineWarning = "#c2410c";
export const kdsButtonColorForegroundOutlineWarningHovered = "#9a3412";
export const kdsButtonColorForegroundOutlineWarningPressed = "#7c2d12";
export const kdsButtonColorForegroundOutlineDanger = "#b91c1c";
export const kdsButtonColorForegroundOutlineDangerHovered = "#991b1b";
export const kdsButtonColorForegroundOutlineDangerPressed = "#7f1d1d";
export const kdsButtonColorForegroundOutlineNeutralHovered = "#403730";
export const kdsButtonColorForegroundOutlineNeutralPressed = "#322a24";
export const kdsButtonColorForegroundOutlineDisabled = "#a69a91";
export const kdsButtonColorForegroundLinkPrimary = "#003ad6";
export const kdsButtonColorForegroundLinkPrimaryHovered = "#0031ba";
export const kdsButtonColorForegroundLinkPrimaryPressed = "#00257d";
export const kdsButtonColorForegroundLinkSecondary = "#cf07be";
export const kdsButtonColorForegroundLinkSecondaryHovered = "#a6069a";
export const kdsButtonColorForegroundLinkSecondaryPressed = "#790070";
export const kdsButtonColorForegroundLinkSuccess = "#15803d";
export const kdsButtonColorForegroundLinkSuccessHovered = "#166534";
export const kdsButtonColorForegroundLinkSuccessPressed = "#14532d";
export const kdsButtonColorForegroundLinkWarning = "#c2410c";
export const kdsButtonColorForegroundLinkWarningHovered = "#9a3412";
export const kdsButtonColorForegroundLinkWarningPressed = "#7c2d12";
export const kdsButtonColorForegroundLinkDanger = "#b91c1c";
export const kdsButtonColorForegroundLinkDangerHovered = "#991b1b";
export const kdsButtonColorForegroundLinkDangerPressed = "#7f1d1d";
export const kdsButtonColorForegroundLinkNeutral = "#50463f";
export const kdsButtonColorForegroundLinkNeutralHovered = "#403730";
export const kdsButtonColorForegroundLinkNeutralPressed = "#322a24";
export const kdsButtonColorForegroundLinkDisabled = "#a69a91";
export const kdsButtonColorBorderSolidPrimary = "#003ad6";
export const kdsButtonColorBorderSolidPrimaryHovered = "#0031ba";
export const kdsButtonColorBorderSolidPrimaryPressed = "#00257d";
export const kdsButtonColorBorderSolidSecondary = "#cf07be";
export const kdsButtonColorBorderSolidSecondaryHovered = "#a6069a";
export const kdsButtonColorBorderSolidSecondaryPressed = "#790070";
export const kdsButtonColorBorderSolidSuccess = "#15803d";
export const kdsButtonColorBorderSolidSuccessHovered = "#166534";
export const kdsButtonColorBorderSolidSuccessPressed = "#14532d";
export const kdsButtonColorBorderSolidWarning = "#c2410c";
export const kdsButtonColorBorderSolidWarningHovered = "#9a3412";
export const kdsButtonColorBorderSolidWarningPressed = "#7c2d12";
export const kdsButtonColorBorderSolidDanger = "#b91c1c";
export const kdsButtonColorBorderSolidDangerHovered = "#991b1b";
export const kdsButtonColorBorderSolidDangerPressed = "#7f1d1d";
export const kdsButtonColorBorderSolidNeutral = "#50463f";
export const kdsButtonColorBorderSolidNeutralHovered = "#403730";
export const kdsButtonColorBorderSolidNeutralPressed = "#322a24";
export const kdsButtonColorBorderSolidDisabled = "#a69a91";
export const kdsButtonColorBorderOutlinePrimary = "#003ad6";
export const kdsButtonColorBorderOutlinePrimaryHovered = "#0031ba";
export const kdsButtonColorBorderOutlinePrimaryPressed = "#00257d";
export const kdsButtonColorBorderOutlineSecondary = "#cf07be";
export const kdsButtonColorBorderOutlineSecondaryHovered = "#a6069a";
export const kdsButtonColorBorderOutlineSecondaryPressed = "#790070";
export const kdsButtonColorBorderOutlineSuccess = "#15803d";
export const kdsButtonColorBorderOutlineSuccessHovered = "#166534";
export const kdsButtonColorBorderOutlineSuccessPressed = "#14532d";
export const kdsButtonColorBorderOutlineWarning = "#c2410c";
export const kdsButtonColorBorderOutlineWarningHovered = "#9a3412";
export const kdsButtonColorBorderOutlineWarningPressed = "#7c2d12";
export const kdsButtonColorBorderOutlineDanger = "#b91c1c";
export const kdsButtonColorBorderOutlineDangerHovered = "#991b1b";
export const kdsButtonColorBorderOutlineDangerPressed = "#7f1d1d";
export const kdsButtonColorBorderOutlineNeutral = "#50463f";
export const kdsButtonColorBorderOutlineNeutralHovered = "#403730";
export const kdsButtonColorBorderOutlineNeutralPressed = "#322a24";
export const kdsButtonColorBorderOutlineDisabled = "#a69a91";
export const kdsButtonColorBorderLinkPrimary = "transparent";
export const kdsButtonColorBorderLinkPrimaryHovered = "transparent";
export const kdsButtonColorBorderLinkPrimaryPressed = "transparent";
export const kdsButtonColorBorderLinkSecondary = "transparent";
export const kdsButtonColorBorderLinkSecondaryHovered = "transparent";
export const kdsButtonColorBorderLinkSecondaryPressed = "transparent";
export const kdsButtonColorBorderLinkSuccess = "transparent";
export const kdsButtonColorBorderLinkSuccessHovered = "transparent";
export const kdsButtonColorBorderLinkSuccessPressed = "transparent";
export const kdsButtonColorBorderLinkWarning = "transparent";
export const kdsButtonColorBorderLinkWarningHovered = "transparent";
export const kdsButtonColorBorderLinkWarningPressed = "transparent";
export const kdsButtonColorBorderLinkDanger = "transparent";
export const kdsButtonColorBorderLinkDangerHovered = "transparent";
export const kdsButtonColorBorderLinkDangerPressed = "transparent";
export const kdsButtonColorBorderLinkNeutral = "transparent";
export const kdsButtonColorBorderLinkNeutralHovered = "transparent";
export const kdsButtonColorBorderLinkNeutralPressed = "transparent";
export const kdsButtonColorBorderLinkDisabled = "transparent";
export const kdsButtonFontFamily = "'Atlas Grotesk', Arial, sans-serif";
export const kdsButtonFontWeight = 700;
export const kdsButtonLineHeight = "1.5";
export const kdsButtonLetterSpacing = "0";
export const kdsButtonBorderRadius = "2px";
export const kdsButtonFontSizeSmall = "14px";
export const kdsButtonFontSizeMedium = "16px";
export const kdsButtonIconSizeSmall = "16px";
export const kdsButtonIconSizeMedium = "18px";
export const kdsButtonMinHeightSmall = "32px";
export const kdsButtonMinHeightMedium = "40px";
export const kdsButtonPaddingBlockSmall = "2px";
export const kdsButtonPaddingBlockMedium = "6px";
export const kdsButtonPaddingInlineSmall = "12px";
export const kdsButtonPaddingInlineMedium = "20px";
export const kdsSizeInputHeightMedium = "38px";
export const kdsSizeInputHeightLarge = "40px";
